import React from 'react';
import cx from 'classnames';
import invoke from 'lodash.invoke';
import {ShowTooltip} from '../Tooltip';

class Button extends React.Component {

    constructor ( props ) {
        super( props );
        this.state = {
            active: false
        };

        this.handleToggle = this.handleToggle.bind( this );
    }

    handleClick = e => {
        const {disabled} = this.props;

        if ( disabled ) {
            e.preventDefault();
            return;
        }

        invoke( this.props, 'onClick', e, this.props );
    };

    handleToggle = ( e ) => {
        e.preventDefault();
        this.setState( prevState => ({active: !prevState.active}) );
    };

    render () {

        const {
            as = 'button',
            appendLabel,
            className,
            iconClassName,
            labelClassName,
            icon,
            href,
            type,
            primary = true,
            secondary,
            tertiary,
            ghosted,
            textLink,
            success,
            error,
            info,
            loading,
            fill,
            fillMobile,
            large,
            small,
            gradient,
            disabled = false,
            tooltip,
            processing,
            onClick,
            children,
            ...props
        } = this.props;

        if ( as === 'a' && href === undefined ) {
            console.warn( as + ' is an <a> tag without an href.' );
        }

        let Element = href ? 'a' : as;
        const Icon = icon;

        const tagsList = [
            'a',
            'div',
            'button',
            'input'
        ];
        if ( !tagsList.includes( Element ) ) {
            Element = 'button'
        }

        const buttonClassName = cx(
            'button',
            {
                primary,
                secondary,
                tertiary,
                ghosted,
                textLink,
                success,
                error,
                info,
                fill,
                gradient,
                'w-full md:w-auto': fillMobile,
                'lg': large,
                'sm': small,
                disabled,
                accept: this.state.active,
                processing: loading || processing
            },
            className
        );

        const _iconClassName = cx(
            'mx-1 -my-2 flex-none',
            {
                'w-4': !large,
                'w-6': large
            },
            iconClassName
        );

        return (
            <ShowTooltip tooltip={tooltip}>
                <Element
                    {...props}
                    href={href}
                    type={type}
                    className={buttonClassName}
                    onClick={this.handleClick}
                    disabled={disabled}>
                    {Icon != null ? <Icon className={_iconClassName}/> : null}
                    <span className={cx( labelClassName )}>{children}</span>
                    {!!appendLabel && <span className="mx-1">{appendLabel}</span>}
                </Element>
            </ShowTooltip>
        )
    }
}

export default Button;
